export const AppFooter = () => (
  <footer className="relative border-t border-white/5 bg-tt-black" data-testid="footer">
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-6 py-14 text-center">
      <div className="flex items-center gap-3">
        <img src="/assets/logo.png" alt="Taurus Technology" className="h-12 w-12 rounded-md object-cover" />
        <div className="text-left leading-none">
          <p className="font-display text-base font-semibold tracking-[0.2em] metallic-text">TAURUS</p>
          <p className="font-grotesk text-[10px] tracking-[0.3em] text-tt-gold">TECHNOLOGY</p>
        </div>
      </div>

      <p className="max-w-md text-sm leading-relaxed text-tt-silver/55">
        Building Software For People Who Perform. Pro music production and live performance apps,
        engineered for the stage.
      </p>

      <div className="mt-2 h-px w-24 glow-line" />

      <div className="flex flex-col items-center gap-1">
        <p className="font-grotesk text-xs text-tt-silver/40">
          © {new Date().getFullYear()} Taurus Technology — All rights reserved.
        </p>
        <p className="font-grotesk text-xs text-tt-silver/40">
          Building Software For People Who <span className="text-tt-gold">Perform.</span>
        </p>
      </div>
    </div>
  </footer>
);
